<script>
    import { handleScoopAjaxError } from '../mixins/axios-response-errors'

    export default {
        props: {
            tree: Object,
            selected: Array,
        },
        data() {
            return {
                loading: false,
                index: null,
                directory: null,
                newDirectory: '',
                renameDirectory: '',
            }
        },
        mounteda() {
            this.setIndexAndDirectory(this.selected);

            this.$nextTick(() => {
                this.initializeTree();
            });
        },
        methods: {
            initializeTree() {
                $('#jstree-actions').jstree({
                    'plugins': ['dnd'],
                    'core': {
                        'themes': {
                            'name': 'proton',
                            'responsive': true
                        },
                        'multiple': false,
                        'check_callback': true
                    }
                });
                $('#jstree-actions').on("changed.jstree", function (e, data) {
                    if (data.node) {
                        this.setIndexAndDirectory(data.node.id);
                    }
                }.bind(this));
                $('#jstree-actions').on("move_node.jstree", function (e, data) {
                    this.moveDirectory(data);
                }.bind(this));
            },
            setIndexAndDirectory(json) {
                _.forEach(JSON.parse(json), (value, key) => {
                    this[key] = value || null;
                });
            },
            createDirectory() {
                this.loading = true;

                axios.post('/mediaserver/directory', {
                    newDirectory: this.newDirectory,
                    filter: {index: this.index, directory: this.directory},
                }).then((response) => {
                    if (response.data.success) {
                        this.newDirectory = '';

                        this.reloadWithDirectory((this.directory || '') + (this.newDirectory ? '::' + this.newDirectory : ''));
                    }
                });
            },
            updateDirectory() {
                this.loading = true;

                let path = this.directory.split('::');
                let oldDirectory = _.last(path);

                path[_.findLastIndex(path)] = this.renameDirectory;
                path = path.join('::')

                if (confirm('You are going to rename the directory from ' + oldDirectory + ' to ' + this.renameDirectory)) {
                    axios.post('/mediaserver/directory/update', {
                        renameDirectory: this.renameDirectory,
                        filter: {index: this.index, directory: this.directory},
                    }).then((response) => {
                        if (response.data.success) {
                            this.reloadWithDirectory(path);
                        }
                    }).catch(error => {
                        handleScoopAjaxError(error);
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                }
            },
            moveDirectory(data) {
                this.loading = true;

                let node = data.node;
                let parent = JSON.parse(data.parent);
                let oldParent = JSON.parse(data.old_parent);

                if (parent.index != oldParent.index) {
                    window.location.reload();
                    return;
                }

                let parentDirectory = parent.directory.split('::').join('/');
                let oldParentDirectory = oldParent.directory.split('::').join('/');

                if (confirm('You are going to move the directory "' + node.text + '"\nfrom ' + oldParentDirectory + ' to ' + parentDirectory + '\n')) {
                    axios.post('/mediaserver/directory/move', {
                        index: parent.index,
                        directory: node.data.labelWithoutCounts,
                        oldParent: oldParentDirectory,
                        newParent: parentDirectory,
                    }).then((response) => {
                        if (response.data.success) {
                            this.reloadWithDirectory(parentDirectory.split('/').join('::'));
                        }
                    });
                } else {
                    this.loading = false;
                }
            },
            deleteDirectory() {
                this.loading = true;

                if (confirm('You are going to delete the directory:\n' + this.directoryReadable)) {
                    axios.post('/mediaserver/directory/destroy', {
                        index: this.index,
                        directory: this.directory
                    }).then(response => {
                        if (response.data.success) {
                            let directory = this.directory.split('::');
                            directory.pop();

                            this.reloadWithDirectory(directory.join('::'));
                        }
                    }).catch(error => {
                        handleScoopAjaxError(error);
                        this.loading = false;
                    })
                } else {
                    this.loading = false;
                }
            },
            reloadWithDirectory(directory) {
                axios.get('/mediaserver/directory').then((response) => {
                    this.$parent.tree = response.data;

                    let selected = JSON.parse(_.first(this.selected));
                    selected.directory = directory;
                    this.$parent.selected = [JSON.stringify(selected)];

                    this.loading = false;
                });
            }
        },
        computed: {
            filteredTree() {
                return _.find(this.tree.children, node => {
                    node = JSON.parse(node.value);

                    return this.index === node.index;
                });
            },
            indexSelected() {
                return !_.isNull(this.index);
            },
            directorySelected() {
                return !_.isNull(this.directory);
            },
            directoryReadable() {
                let directory = this.index + (this.directory || '');

                return directory.split('::').join('/');
            },
            newDirectoryIsEmpty() {
                return this.newDirectory == '';
            },
            lastDirectory() {
                if (!this.directory) {
                    return '';
                }

                return _.last(this.directory.split('::'));
            },
        },
        watch: {
            directory() {
                this.renameDirectory = this.lastDirectory;
            },
            loading() {
                if (!this.loading) {
                    this.setIndexAndDirectory(this.selected);

                    this.$nextTick(() => {
                        this.initializeTree();
                    });
                }
            }
        }
    }
</script>

<template>
    <div>
        <button class="btn btn-sm btn-outline btn-primary">
            <i class="fa fa-clone" aria-hidden="true"></i>
            <span>Move files </span>
        </button>
    </div>
</template>
